import styled from "styled-components";

export const WorkerItemStyles = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.semantic.outline.default};
  border-radius: 3px;
  padding: 4px 8px;
  margin-bottom: 12px;

  &:last-child {
    margin-bottom: 0;
  }

  .nameContainer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;

    .name {
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      color: ${({ theme }) => theme.colors.semantic.text.strong};
    }

    .arrow {
      cursor: pointer;
      transition: all 0.2s ease-in-out;
      transform: rotate(0deg);
    }

    .arrowUp {
      transform: rotate(180deg);
    }
  }

  .description {
    height: 0px;
    overflow: hidden;
    transition: all 0.2s ease-in-out;
    .data {
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 20px;
      color: ${({ theme }) => theme.colors.semantic.text.weak};
    }

    .data1 {
      margin-top: 8px;
    }
  }
`;
